export const oxfordCommaList = (items) => {
  if (items.length === 0) return '';
  if (items.length === 1) return items[0];

  return items
    .map((item, index) => {
      return index === items.length - 1 ? `and ${item}` : item;
    })
    .join(', ');
};

export const encodeFormData = (data) => {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
};

const exceptions = ['of', 'the', 'and'];

export const convertToTitleCase = (str) => {
  if (!str) {
    return '';
  }

  return str
    .toLowerCase()
    .split(' ')
    .map((word, i) => {
      return exceptions.includes(word) && i !== 0
        ? word
        : word.charAt(0).toUpperCase().concat(word.substr(1));
    })
    .join(' ');
};
